module.exports = __webpack_public_path__ + "img/game6.87ec3a71.png";